var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "persistent", width: "300" },
          model: {
            value: _vm.loader,
            callback: function($$v) {
              _vm.loader = $$v
            },
            expression: "loader"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { color: "#0855c4" } },
            [
              _c(
                "v-card-text",
                { staticStyle: { color: "#fff" } },
                [
                  _vm._v(_vm._s(_vm.textLoader)),
                  _c("v-progress-linear", {
                    staticClass: "mb-0 progress-animation",
                    attrs: { indeterminate: "indeterminate", color: "white" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04a0d67a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04a0d67a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = null
// module chunks = 